import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import TimeLineTarget from "./TimeLine/TimeLineTarget";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//import ModalAgregarLineasScorecard from './ModalAgregarLineasScorecard';
import { LoaderScreen } from "../../components/LoaderScreen";
import { FiltradoOperacionesCredito } from "./FiltradoOperacionesCredito";

import { GetMonthName } from "../../helpers/GetMonthName";

export const TiemposOperacionScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [titulo, setTitulo] = useState("ESTIMACIONES DE TIEMPO DE OPERACION");
  const [hasSearched, setHasSearched] = useState(false);

  const [state, setState] = useState({
    TipoCredito: "",
    idproceso: "",
    medida: "",
    tiempoestimado: "",
    PromedioDuracion: "",
  });

  const [data, setData] = useState([]);

  const onExecute = (ejercicio, periodo) => {
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `CargaPromedioDuracionTimeline/PromedioTimeline?ejercicio=${ejercicio}&periodo=${periodo}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setData(result);
          setTitulo(
            "ESTIMACIONES DE TIEMPO DE OPERACION " +
            GetMonthName(periodo).toUpperCase() +
            " " +
            ejercicio
          );
          setHasSearched(true);
          resolve("");
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };

  const filteredDataCMH = data.filter((data) => data.tipoCredito === "CMH");
  const filteredDataJDF = data.filter((data) => data.tipoCredito === "JDF");
  const filteredDataCON = data.filter((data) => data.tipoCredito === "CON");
  const formatDuration = (tiempoestimado, medida) => {
    const unidad = medida === "H" ? "hora" : "día";
    const pluralUnidad = medida === "H" ? "horas" : "días";
    return `${tiempoestimado} ${tiempoestimado === 1 ? unidad : pluralUnidad}`;
  };

  const formatDurationProm = (promedio, medida) => {
    const unidad = medida === "H" ? "hora" : "día";
    const pluralUnidad = medida === "H" ? "hrs" : "días";
    return `${promedio} ${promedio === 1 ? unidad : pluralUnidad}`;
  };

  const formatDurationProm2 = (promedioDuracion, medida) => {
    const unidad = medida === "H" ? "hrs" : "días";
    return (
      <div>
        <div className="cantidad-promedio">{promedioDuracion}</div>
        <div className="medida">{unidad}</div>
      </div>
    );
  };

  const calculateTotalTimes = (data) => {
    let totalEstimado = 0;
    let totalPromedio = 0;

    data.forEach((item) => {
      const factor = item.medida === "H" ? 1 : 24;
      totalEstimado += item.tiempoestimado * factor;
      totalPromedio += item.promedioDuracion * factor;
    });

    const convertToDaysHours = (totalHours) => {
      const dias = Math.floor(totalHours / 24);
      const horas = totalHours % 24;
      return `${dias} días y ${horas} horas`;
    };

    return {
      totalEstimado: convertToDaysHours(totalEstimado),
      totalPromedio: convertToDaysHours(totalPromedio),
    };
  };

  const calculateTotalTimesInDays = (data) => {
    let totalEstimado = 0;
    let totalPromedio = 0;

    data.forEach((item) => {
      const factor = item.medida === "H" ? 1 : 24;
      totalEstimado += item.tiempoestimado * factor;
      totalPromedio += item.promedioDuracion * factor;
    });

    const convertToDays = (totalHours) => {
      return Math.floor(totalHours / 24); // Convierte horas a días completos
    };

    return {
      totalEstimado: convertToDays(totalEstimado),
      totalPromedio: convertToDays(totalPromedio),
    };
  };

  const totalTimesCMHdias = calculateTotalTimesInDays(filteredDataCMH);
  const totalTimesJDFdias = calculateTotalTimesInDays(filteredDataJDF);
  const totalTimesCONdias = calculateTotalTimesInDays(filteredDataCON);
  const onFiltrar = (linea, proceso) => {
    var result = data.filter(
      (data) => data.tipoCredito === linea && data.idproceso === proceso
    );
    if (result === undefined || result === null || result.length === 0) {
      return 0;
    } else {
      return result[0];
    }
  };

  return (
    <PlantillaScreen
      titulo={"ESTIMACIONES DE TIEMPO DE OPERACION"}
      className_main={1}
      className={"tiempos-operacion-main-screen"}
    >
      <LoaderScreen loader={loader} />
      <div className="tiempos-operacion-actions">
        <div
          className="tiempos-operacion-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <FiltradoOperacionesCredito onExecute={onExecute} />
      </div>
      <div className="tiempos-operacion-mhusa-timeline-title ">
        Tiempo promedio de solicitud de crédito MHUSA 
      </div>
      {hasSearched && filteredDataCMH.length > 0 && (
        <div className="tiempos-operacion-mhusa-timeline scroll-4">
          <TimeLineTarget
            icon={onFiltrar("CMH", 28).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 28).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 28).tiempoestimado}
            medida={onFiltrar("CMH", 28).medida}
            title={"Validar Condiciones Operación"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[1].promedioDuracion, filteredDataCMH[1].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 28).tiempoestimado,
                  onFiltrar("CMH", 28).medida
                ),
            }}
            value={1}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 29).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 29).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 29).tiempoestimado}
            medida={onFiltrar("CMH", 29).medida}
            title={"Validar Pedido"}
            subtitle={"Gerente Sucursal"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[2].promedioDuracion, filteredDataCMH[2].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 29).tiempoestimado,
                  onFiltrar("CMH", 29).medida
                ),
            }}
            value={2}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 30).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 30).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 30).tiempoestimado}
            medida={onFiltrar("CMH", 30).medida}
            title={"Cargar Documentación"}
            subtitle={"Asesor de Ventas"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[3].promedioDuracion, filteredDataCMH[3].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 30).tiempoestimado,
                  onFiltrar("CMH", 30).medida
                ),
            }}
            value={3}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 31).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 31).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 31).tiempoestimado}
            medida={onFiltrar("CMH", 31).medida}
            title={"Analizar Documentación"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[4].promedioDuracion, filteredDataCMH[4].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 31).tiempoestimado,
                  onFiltrar("CMH", 31).medida
                ),
            }}
            value={4}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 32).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 32).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 32).tiempoestimado}
            medida={onFiltrar("CMH", 32).medida}
            title={"Analizar Otorgamiento de Crédito"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[5].promedioDuracion, filteredDataCMH[5].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 32).tiempoestimado,
                  onFiltrar("CMH", 32).medida
                ),
            }}
            value={5}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 33).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 33).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 33).tiempoestimado}
            medida={onFiltrar("CMH", 33).medida}
            title={"Cargar Documentación"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[6].promedioDuracion, filteredDataCMH[6].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 33).tiempoestimado,
                  onFiltrar("CMH", 33).medida
                ),
            }}
            value={6}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 34).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 34).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 34).tiempoestimado}
            medida={onFiltrar("CMH", 34).medida}
            title={"Autorizar Facturación"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[7].promedioDuracion, filteredDataCMH[7].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 34).tiempoestimado,
                  onFiltrar("CMH", 34).medida
                ),
            }}
            value={7}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 35).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 35).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 35).tiempoestimado}
            medida={onFiltrar("CMH", 35).medida}
            title={"Validar Enganche"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[8].promedioDuracion, filteredDataCMH[8].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 35).tiempoestimado,
                  onFiltrar("CMH", 35).medida
                ),
            }}
            value={8}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 36).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 36).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 36).tiempoestimado}
            medida={onFiltrar("CMH", 36).medida}
            title={"Facturar Equipo"}
            subtitle={"Cajera/Asistente ventas"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[9].promedioDuracion, filteredDataCMH[9].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 36).tiempoestimado,
                  onFiltrar("CMH", 36).medida
                ),
            }}
            value={9}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 37).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 37).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 37).tiempoestimado}
            medida={onFiltrar("CMH", 37).medida}
            title={"Cargar Pagare EQUIP"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[10].promedioDuracion, filteredDataCMH[10].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 37).tiempoestimado,
                  onFiltrar("CMH", 37).medida
                ),
            }}
            value={10}
          />
          <TimeLineTarget
            icon={onFiltrar("CMH", 38).promedioDuracion}
            duracionPromedio={onFiltrar("CMH", 38).promedioDuracion}
            tiempoEstimado={onFiltrar("CMH", 38).tiempoestimado}
            medida={onFiltrar("CMH", 38).medida}
            title={"Finalizar Solicitud"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCMH[11].promedioDuracion, filteredDataCMH[11].medida),
              tiempoestimado:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CMH", 38).tiempoestimado,
                  onFiltrar("CMH", 38).medida
                ),
            }}
            value={11}
            endtarget={true}
          />
        </div>
      )}
      <div className="tiempos-operacion-jdf-timeline-title ">
        Tiempo promedio de solicitud de crédito JDF
      </div>
      {hasSearched && filteredDataJDF.length > 0 && (
        <div className="tiempos-operacion-jdf-timeline scroll-4">
          <TimeLineTarget
            icon={onFiltrar("JDF", 2).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 2).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 2).tiempoestimado}
            medida={onFiltrar("JDF", 2).medida}
            title={"Validar Pedido"}
            subtitle={"Gerente de sucursal"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[1].promedioDuracion, filteredDataJDF[1].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 2).tiempoestimado,
                  onFiltrar("JDF", 2).medida
                ),
              comentarios: "",
            }}
            value={1}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 7).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 7).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 7).tiempoestimado}
            medida={onFiltrar("JDF", 7).medida}
            title={"Validar condiciones"}
            subtitle={"Coordinador JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[1].promedioDuracion, filteredDataJDF[1].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 7).tiempoestimado,
                  onFiltrar("JDF", 7).medida
                ),
              comentarios: "",
            }}
            value={1}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 12).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 12).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 12).tiempoestimado}
            medida={onFiltrar("JDF", 12).medida}
            title={"Asignar Promotor"}
            subtitle={"Coordinador JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[2].promedioDuracion, filteredDataJDF[2].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 12).tiempoestimado,
                  onFiltrar("JDF", 12).medida
                ),
              comentarios: "",
            }}
            value={2}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 13).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 13).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 13).tiempoestimado}
            medida={onFiltrar("JDF", 13).medida}
            title={"Analizar Documentación"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[3].promedioDuracion, filteredDataJDF[3].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 13).tiempoestimado,
                  onFiltrar("JDF", 13).medida
                ),
              comentarios: "",
            }}
            value={3}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 14).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 14).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 14).tiempoestimado}
            medida={onFiltrar("JDF", 14).medida}
            title={"Capturar Solicitud ANFEXI"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[4].promedioDuracion, filteredDataJDF[4].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 14).tiempoestimado,
                  onFiltrar("JDF", 14).medida
                ),
              comentarios: "",
            }}
            value={4}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 15).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 15).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 15).tiempoestimado}
            medida={onFiltrar("JDF", 15).medida}
            title={"Preanalisis"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[5].promedioDuracion, filteredDataJDF[5].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 15).tiempoestimado,
                  onFiltrar("JDF", 15).medida
                ),
              comentarios: "",
            }}
            value={5}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 16).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 16).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 16).tiempoestimado}
            medida={onFiltrar("JDF", 16).medida}
            title={"Validar Documentación"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[6].promedioDuracion, filteredDataJDF[6].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 16).tiempoestimado,
                  onFiltrar("JDF", 16).medida
                ),
              comentarios: "",
            }}
            value={6}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 17).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 17).promedioDuracion}
            tiempoEstimado={filteredDataJDF[7].tiempoestimado}
            medida={onFiltrar("JDF", 17).medida}
            title={"Precalificación"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[7].promedioDuracion, filteredDataJDF[7].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 17).tiempoestimado,
                  onFiltrar("JDF", 17).medida
                ),
              comentarios: "",
            }}
            value={7}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 18).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 18).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 18).tiempoestimado}
            medida={onFiltrar("JDF", 18).medida}
            title={"Reporte de Campo"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[8].promedioDuracion, filteredDataJDF[8].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 18).tiempoestimado,
                  onFiltrar("JDF", 18).medida
                ),
              comentarios: "",
            }}
            value={8}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 19).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 19).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 19).tiempoestimado}
            medida={onFiltrar("JDF", 19).medida}
            title={"Validar Reporte de Campo"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[9].promedioDuracion, filteredDataJDF[9].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 19).tiempoestimado,
                  onFiltrar("JDF", 19).medida
                ),
              comentarios: "",
            }}
            value={9}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 20).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 20).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 20).tiempoestimado}
            medida={onFiltrar("JDF", 20).medida}
            title={"Integrar Documentación ANFEXI"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[10].promedioDuracion, filteredDataJDF[10].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 20).tiempoestimado,
                  onFiltrar("JDF", 20).medida
                ),
              comentarios: "",
            }}
            value={10}
          />

          <TimeLineTarget
            icon={onFiltrar("JDF", 21).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 21).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 21).tiempoestimado}
            medida={onFiltrar("JDF", 21).medida}
            title={"Dictamen"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[11].promedioDuracion, filteredDataJDF[11].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 21).tiempoestimado,
                  onFiltrar("JDF", 21).medida
                ),
              comentarios: "",
            }}
            value={11}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 22).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 22).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 22).tiempoestimado}
            medida={onFiltrar("JDF", 22).medida}
            title={"Autorizar Facturacion"}
            subtitle={"Gerencia Finanzas"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[12].promedioDuracion, filteredDataJDF[12].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 22).tiempoestimado,
                  onFiltrar("JDF", 22).medida
                ),
              comentarios: "",
            }}
            value={12}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 23).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 23).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 23).tiempoestimado}
            medida={onFiltrar("JDF", 23).medida}
            title={"Facturar Equipo"}
            subtitle={"Ventas"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[13].promedioDuracion, filteredDataJDF[13].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 23).tiempoestimado,
                  onFiltrar("JDF", 23).medida
                ),
              comentarios: "",
            }}
            value={13}
          />

          <TimeLineTarget
            icon={onFiltrar("JDF", 24).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 24).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 24).tiempoestimado}
            medida={onFiltrar("JDF", 24).medida}
            title={"Validar Factura"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[14].promedioDuracion, filteredDataJDF[14].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 24).tiempoestimado,
                  onFiltrar("JDF", 24).medida
                ),
              comentarios: "",
            }}
            value={14}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 25).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 25).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 25).tiempoestimado}
            medida={onFiltrar("JDF", 25).medida}
            title={"Analizar Contrato"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[15].promedioDuracion, filteredDataJDF[15].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 25).tiempoestimado,
                  onFiltrar("JDF", 25).medida
                ),
              comentarios: "",
            }}
            value={15}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 26).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 26).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 26).tiempoestimado}
            medida={onFiltrar("JDF", 26).medida}
            title={"Cargar Contrato"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[16].promedioDuracion, filteredDataJDF[16].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 26).tiempoestimado,
                  onFiltrar("JDF", 26).medida
                ),
              comentarios: "",
            }}
            value={16}
          />
          <TimeLineTarget
            icon={onFiltrar("JDF", 27).promedioDuracion}
            duracionPromedio={onFiltrar("JDF", 27).promedioDuracion}
            tiempoEstimado={onFiltrar("JDF", 27).tiempoestimado}
            medida={onFiltrar("JDF", 27).medida}
            title={"Cotejar Informacion"}
            subtitle={"Promotor JDF"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataJDF[16].promedioDuracion, filteredDataJDF[16].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("JDF", 27).tiempoestimado,
                  onFiltrar("JDF", 27).medida
                ),
              comentarios: "",
            }}
            value={16}
          />
        </div>
      )}
      <div className="tiempos-operacion-contado-timeline-title ">
        Tiempo promedio de solicitud de crédito contado
      </div>
      {hasSearched && filteredDataCON.length > 0 && (
        <div className="tiempos-operacion-contado-timeline scroll-4">
          {/* <TimeLineTarget
                        icon={totalTimesCONdias.totalPromedio}
                        duracionPromedio={totalTimesCONdias.totalPromedio}
                        tiempoEstimado={totalTimesCONdias.totalEstimado}
                        medida={filteredDataCON[0].medida}
                        title={"Tiempo Total"}
                        subtitle={"del Proceso"}
                        footer={{
                            duracion: 'Tiempo Estimado: ' + totalTimesCONdias.totalEstimado + " día",
                            // leyenda: 'Duración Promedio: ' + totalTimesCONdias.totalPromedio + " días",
                        }}
                        value={17}
                    />
                    <TimeLineTarget
                        icon={filteredDataCON[0].promedioDuracion}
                        duracionPromedio={filteredDataCON[0].promedioDuracion}
                        tiempoEstimado={filteredDataCON[0].tiempoestimado}
                        medida={filteredDataCON[0].medida}
                        title={"Genero Solicitud"}
                        subtitle={"Vendedor"}
                        footer={{
                            // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCON[0].promedioDuracion, filteredDataCON[0].medida),
                            duracion: 'Tiempo Estimado: ' + formatDuration(filteredDataCON[0].tiempoestimado, filteredDataCON[0].medida),
                            comentarios: "",
                        }}
                        value={0}
                    /> */}
          <TimeLineTarget
            icon={onFiltrar("CON", 30).promedioDuracion}
            duracionPromedio={onFiltrar("CON", 30).promedioDuracion}
            tiempoEstimado={onFiltrar("CON", 30).tiempoestimado}
            medida={onFiltrar("CON", 30).medida}
            title={"Cargar Documentacion"}
            subtitle={"Coordinador Credito"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCON[1].promedioDuracion, filteredDataCON[1].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CON", 30).tiempoestimado,
                  onFiltrar("CON", 30).medida
                ),
              comentarios: "",
            }}
            value={1}
          />
          <TimeLineTarget
            icon={onFiltrar("CON", 34).promedioDuracion}
            duracionPromedio={onFiltrar("CON", 34).promedioDuracion}
            tiempoEstimado={onFiltrar("CON", 34).tiempoestimado}
            medida={onFiltrar("CON", 34).medida}
            title={"Validar Deposito"}
            subtitle={"Gerente Sucursal"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCON[2].promedioDuracion, filteredDataCON[2].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CON", 34).tiempoestimado,
                  onFiltrar("CON", 34).medida
                ),
              comentarios: "",
            }}
            value={2}
          />
          <TimeLineTarget
            icon={onFiltrar("CON", 36).promedioDuracion}
            duracionPromedio={onFiltrar("CON", 36).promedioDuracion}
            tiempoEstimado={onFiltrar("CON", 36).tiempoestimado}
            medida={onFiltrar("CON", 36).medida}
            title={"Facturar Equipo"}
            subtitle={"Gerente Sucursal"}
            footer={{
              // leyenda: 'Duración Promedio: ' + formatDurationProm(filteredDataCON[3].promedioDuracion, filteredDataCON[3].medida),
              duracion:
                "Tiempo Estimado: " +
                formatDuration(
                  onFiltrar("CON", 36).tiempoestimado,
                  onFiltrar("CON", 36).medida
                ),
            }}
            value={3}
          />
        </div>
      )}
    </PlantillaScreen>
  );
};
